import { Component } from '@angular/core';
import { BarStackNormalizationChartComponent } from '../bar-stack-normalization-chart/bar-stack-normalization-chart.component';
import { LineChartComponent } from '../line-chart/line-chart.component';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  imports: [BarStackNormalizationChartComponent, LineChartComponent],
})
export class OverviewComponent {
  isLoadDate: boolean = false;

  onDataBound(isLoadDate: boolean) {
    this.isLoadDate = isLoadDate;
  }
}
